import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/user/getUser'
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation() {
  try {
    const response = yield call(axios.get, 
      `${config.API_URL}/user/me`,
      { headers: getLocalUser() }
      );
    // Mirror the fresh user doc into localStorage so preferences read
    // outside React (utils/datetime reads the timezone from there for
    // every date rendered in the app) never go stale.
    const freshUser = response.data?.data?.user;
    if (freshUser) {
      try {
        const stored = JSON.parse(localStorage.getItem('user') || '{}');
        localStorage.setItem('user', JSON.stringify({ ...stored, ...freshUser }));
      } catch (_e) {
        localStorage.setItem('user', JSON.stringify(freshUser));
      }
    }
    yield put(fetchSuccess(response.data.data));
  } catch (error) {
    console.error('getUser saga: Error occurred:', error);
    console.error('getUser saga: Error response:', error?.response?.data);
    console.error('getUser saga: Error status:', error?.response?.status);
    yield put(Error(error))
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
